import { C } from "./const";

export default function Logo({ ...props }) {

    return (
        <div {...props}>
            <a
            href="/"
                style={{
                    width: 90,
                    height: 90,
                    backgroundImage: "url('/logo.jpg')",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 900,
                    fontSize: 18,
                    flexShrink: 0,
                    backgroundSize: 'cover'
                }}
            >

            </a>
            <div>
                <div style={{ color: C.white, fontWeight: 800, fontSize: 15, lineHeight: 1.2 }}>
                    سحر محمودآبادی
                </div>
                <div style={{ color: C.accent, fontSize: 11, fontWeight: 400 }}>
                    نمایندگی رسمی
                </div>
            </div>
        </div>);
}